<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand id="brand" class="d-lg-none"  to="/">
      <CIcon class="logo" name="logo" height="48" alt="Prefeitura de Timóteo"/>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/profile">
         Consultar
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/editar" exact>
          Editar Currículo
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/definicoes">
          Definições da Conta
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="mr-0">
      <RouterLink v-if="admin" to="/admin"><i class="fas fa-users-cog text-dark"></i></RouterLink>
      <TheHeaderDropdownAccnt/>
      
    </CHeaderNav>   
  </CHeader>
</template>

<script>
import firebase from "firebase";
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt
  },
  data() {
    return {
    }
  },

  computed: {
    admin() {
      const buscaId = firebase.auth().currentUser.email

    if(buscaId == 'timoteo@timoteo.com') {
     return true
    } else {
      return false
    }

    }
  }
}
</script>

<style lang="scss" scoped>
a >.admin {
  color: #000 !important;
  margin-right: -11px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.text-dark{
  background: transparent;
  width: 10px;
  
}

#brand {
  margin-left: auto; 
  margin-right: auto;   
  display: inline-block;
  
  @media (max-width: 370px) {
    margin-left: 0px;   
    padding-top: 10px;
    .logo {

      height: 35px;

    }
    }
}
</style>